import { applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";

//import requestQueueMiddleware from "middlewares/requestQueue";
import superagentMiddleware from "middlewares/superagent";

export default applyMiddleware(thunkMiddleware, superagentMiddleware, thunkMiddleware);



// WEBPACK FOOTER //
// ./src/middlewares/index.js